<header class="layout-header">
  <div class="toolbar-box">
    <div class="toolbar-inner-box">
      <div class="toolbar__pc">
        <div class="left-box">
          <nav class="toolbar-nav">
            <ul class="toolbar-list">
              <li class="toolbar-item">
                <a
                  class="toolbar-link"
                  routerLink="/about"
                  routerLinkActive="active"
                >
                  <span class="text__fixed">AB</span>
                  <span class="text__bottom">O</span>
                  <span class="text__fixed">UT</span>
                </a>
              </li>

              <li class="toolbar-item">
                <a
                  class="toolbar-link"
                  routerLink="/project"
                  routerLinkActive="active"
                >
                  <span class="text__fixed">PR</span>
                  <span class="text__bottom">O</span>
                  <span class="text__fixed">JECT</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div class="center-box">
          <a class="toolbar-logo-link" routerLink="/index">
            <img
              class="toolbar-logo"
              libSrc="/assets/icons/toolbar-ososo-logo.png"
              alt="toolbar-ososo-logo"
            />
          </a>
        </div>

        <div class="right-box">
          <nav class="toolbar-nav">
            <ul class="toolbar-list">
              <li class="toolbar-item">
                <a
                  class="toolbar-icon-link"
                  href="https://www.instagram.com/ososo_studio/"
                  target="_blank"
                >
                  <i class="svg-icon insta-icon"></i>
                </a>
              </li>

              <li class="toolbar-item">
                <a class="toolbar-link" (click)="openContact()">
                  <span class="text__fixed">C</span>
                  <span class="text__bottom">O</span>
                  <span class="text__fixed">NTACT</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div class="toolbar__mobile">
        <div class="left-box">
          <a class="toolbar-logo-link" routerLink="/index">
            <img
              class="toolbar-logo"
              libSrc="/assets/icons/toolbar-ososo-logo.png"
              alt="toolbar-ososo-logo"
            />
          </a>
        </div>

        <div class="right-box">
          <a class="toolbar-menu-link" (click)="openMenu()">
            <img
              class="toolbar-menu-icon"
              libSrc="/assets/icons/toolbar-menu-icon.png"
              alt="toolbar-menu-icon"
            />
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="toolbar-mobile-menu-box" [class.menu__open]="isMenuOpen">
    <div class="toolbar-mobile-inner-box">
      <div class="top-box">
        <div class="toolbar-mobile-menu-header-box">
          <a class="toolbar-close-link">
            <img
              libSrc="/assets/icons/mobile-toolbar-close-icon.png"
              alt="menu-close-icon"
            />
          </a>
        </div>

        <nav class="nav-toolbar-mobile-nav">
          <ul class="toolbar-mobile-nav-list">
            <li class="toolbar-mobile-nav-item">
              <a
                class="toolbar-mobile-nav-link toolbar-close-link"
                routerLink="/about"
                routerLinkActive="active"
                >ABOUT</a
              >
            </li>

            <li class="toolbar-mobile-nav-item">
              <a
                class="toolbar-mobile-nav-link toolbar-close-link"
                routerLink="/project"
                routerLinkActive="active"
                >PROJECT</a
              >
            </li>

            <li class="toolbar-mobile-nav-item">
              <a
                class="toolbar-mobile-nav-link toolbar-close-link"
                href="https://www.instagram.com/ososo_studio/"
                target="_blank"
              >
                <i class="svg-icon insta-icon"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <div class="contact-box">
        <div class="contact-card-box">
          <div class="contact-header">
            <img
              class="contact-header-icon"
              libSrc="/assets/icons/contact-header-s-icon.png"
              alt="contact-header-icon"
            />
            <img
              class="contact-header-icon center-header-icon"
              libSrc="/assets/icons/contact-header-o-icon.png"
              alt="contact-header-icon"
            />
            <img
              class="contact-header-icon"
              libSrc="/assets/icons/contact-header-s-icon.png"
              alt="contact-header-icon"
            />
          </div>

          <div class="contact-contents">
            <dl class="contact-info-list">
              <dd class="contact-info-item contact-info-item-box">
                <p class="contact-info-label">CONTACT</p>

                <img
                  class="contact-arrow-icon"
                  libSrc="/assets/icons/contact-arrow-icon.png"
                  alt="contact-arrow-icon"
                />

                <img
                  class="contact-arrow-sm-icon"
                  libSrc="/assets/icons/contact-arrow-sm-icon.png"
                  alt="contact-arrow-sm-icon"
                />

                <div class="contact-info-box">
                  <p class="contact-info">+82 10.8811.8991</p>
                  <p class="contact-info">ososo_0@naver.com</p>
                </div>
              </dd>

              <dd class="contact-info-item">
                <p class="contact-info-label">OFFICE</p>

                <img
                  class="contact-arrow-icon"
                  libSrc="/assets/icons/contact-arrow-icon.png"
                  alt="contact-arrow-icon"
                />

                <img
                  class="contact-arrow-sm-icon"
                  libSrc="/assets/icons/contact-arrow-sm-icon.png"
                  alt="contact-arrow-sm-icon"
                />

                <div class="contact-info-box">
                  <p class="contact-info margin-bottom__other">
                    제주특별자치도 제주시<br class="show-at-sm" />
                    탑동로 31, 3F
                  </p>

                  <p class="contact-info">
                    <span class="transform-text-box">
                      M<span class="transform-text">O</span>N
                    </span>
                    - FRI 9:00-18:00
                  </p>
                </div>
              </dd>
            </dl>
          </div>

          <div class="contact-bottom">
            <img
              class="contact-bottom-icon"
              libSrc="/assets/icons/contact-bottom-icon.png"
              alt="contact-bottom-icon"
            />

            <a class="contact-download-link" (click)="download()"
              >Download Portfolio</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
